module.exports = (el) => {
  const modal = $(el);
  const submitBtn = modal.find('#sendWelcomeEmailBtn');
  const form = modal.find('#sendWelcomeEmailForm');

  modal.on('show.bs.modal', (e) => {
    modal.find('input[type=checkbox]').prop('checked', true).change();
  });

  submitBtn.click(function () {
    const dataArr = form.serializeArray();
    const btns = $(this).parent().find('button');

    const invoiceId = $(this).data('invoice-id');
    const userIds = $.map(dataArr, (n) => n.name);

    btns.loading();

    $.post(urlSendWelcomeEmail, {
      invoiceId,
      userIds
    }).success((data, b) => {
      toastr.success(`Welcome email successfully sent to ${data.emails.join(', ')}`, 'Success');

      modal.modal('hide');
    }).always(() => {
      btns.loading('reset');
    });
  });
};
